import { YearOfStudy } from "../model/year-of-study";

export interface DossierReferencesDto {
  id: string;
  code: string;
  libelle: string;
  codeSiel: string;
  codeSielCEFA: string;
  dateDebut: string;
  dateFin: string;
  horsService: boolean;
  ordreTri: number;
  niveaux: string[];
}

export const DossierReferencesDtoMapper = {
  toDto: (data: YearOfStudy): DossierReferencesDto => {
    return {
    } as DossierReferencesDto;
  },
  toDomain: (dto: DossierReferencesDto): YearOfStudy => {
    return {
      id: dto.id,
      code: dto.code,
      label: dto.libelle,
      sielCode: dto.codeSiel,
      sielCEFACode: dto.codeSielCEFA,
      startDate: dto.dateDebut,
      endDate: dto.dateFin,
      outOfService: dto.horsService,
      sortOrder: dto.ordreTri,
      levels: dto.niveaux,
    } as YearOfStudy;
  }
};